import React, { forwardRef, ReactNode } from 'react';
import {
  AccordionItem as ChakraAccordionItem,
  AccordionItemProps,
  useStyleConfig,
} from '@chakra-ui/react';

interface Props extends Omit<AccordionItemProps, `css`> {
  children: ReactNode;
  defaultIndex?: any
}

export const AccordionItem = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`AccordionItem`);

    return (
      <ChakraAccordionItem ref={ref} __css={styles} {...props}>
        {children}
      </ChakraAccordionItem>
    );
  }
);
export type { Props as AccordionItemProps };
